module.exports = __webpack_public_path__ + "static/img/novalloy-metal-micro-imaging-anodized-aluminum02.963e72a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/novalloy/novalloy-metal-micro-imaging-anodized-aluminum02.jpg
// module id = 784
// module chunks = 0